import axios from 'axios';

import { IS_CLIENT_SIDE } from '@dr.pogodin/react-utils';

import type { SetBetaTesterBodyT, SetBetaTesterResT } from 'server/controllers';

import { P_API_USER_BETA_TESTER, type UserT, getConfig } from 'utils';

export async function setBetaTester(
  userId: string,
  betaTester: boolean,
): Promise<UserT> {
  if (!IS_CLIENT_SIDE) throw Error('Client-side only');

  const config = getConfig(true);

  const res = await axios.post<SetBetaTesterResT>(
    P_API_USER_BETA_TESTER(userId),
    {
      _csrf: config.CSRF,
      betaTester,
    } satisfies SetBetaTesterBodyT,
  );

  return res.data;
}
